import { FileDto } from '../models/dto/file.dto';
import { RoomMessageDto } from '../models/dto/room-message.dto';
import { RoomMessage } from '../models/interfaces/room-message.interface';

export const createRoomMessage = (
  idRoom: string,
  idAuthor: string,
  text: string,
  file?: File,
  shouldNotCreateTicket: boolean = false
): RoomMessage => {
  return {
    idRoom: idRoom,
    idAuthor: idAuthor,
    text: text,
    dtMessage: new Date(),
    active: true,
    sent: true,
    allMembersVisualized: false,
    allMembersReceived: false,
    attachment: file ? { file } : undefined,
    membersWhoVisualized: [idAuthor],
    shouldNotCreateTicket: shouldNotCreateTicket
  };
};

export const createRoomMessageDto = (
  idRoom: string,
  idAuthor: string,
  authorName: string,
  text: string,
  isdFiles: string[]
): RoomMessageDto => {
  return {
    idRoom: idRoom,
    idAuthor: idAuthor,
    authorName: authorName,
    text: text,
    dtMessage: new Date(),
    active: true,
    sent: true,
    allMembersVisualized: false,
    allMembersReceived: false,
    files: isdFiles.length > 0 ? isdFiles : [],
    membersWhoVisualized: [idAuthor],
  };
};
